import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        uploadDocument: (data) => executeCall(() => Axios.post(url, data, { headers: { ...getHeaders(), "Content-Type": "multipart/form-data", } })),
        updateDocument: (data) => executeCall(() => Axios.patch(url, data, { headers: { ...getHeaders(), "Content-Type": "multipart/form-data", } })),
        deleteDocument: (id) => executeCall(() => Axios.delete(url + `/${id}`, { headers: getHeaders() })),
    };
};


export default crudder;